import { PaymentMethod, AdyenBrands } from "@grandvisionhq/payments";
const BrandsMap = {
  [AdyenBrands.VISA]: "visa",
  [AdyenBrands.MASTERCARD]: "masterCard",
  [AdyenBrands.AMEX]: "amex",
  [AdyenBrands.MAESTRO]: "maestro",
  [AdyenBrands.BANCONTACTMC]: "bcmc"
  /* BANCONTACTMC */
};
const mapCartExpressPaymentMethods = (cartPaymentMethods) => {
  if (cartPaymentMethods.length === 0) {
    return [];
  }
  const applePayPaymentMethod = cartPaymentMethods?.find(
    (paymentMethod) => paymentMethod?.name === PaymentMethod.APPLE_PAY
  );
  if (applePayPaymentMethod?.brands) {
    return applePayPaymentMethod.brands.map((adyenBrand) => BrandsMap[adyenBrand] ?? adyenBrand).filter((brand) => !!brand);
  }
  return [];
};
const mapCartRegularPaymentMethods = (cartPaymentMethods) => {
  if (cartPaymentMethods.length === 0) {
    return [];
  }
  const applePayPaymentMethod = cartPaymentMethods?.find(
    (paymentMethod) => paymentMethod?.name === PaymentMethod.APPLE_PAY
  );
  if (applePayPaymentMethod?.brands) {
    return applePayPaymentMethod.brands.map((adyenBrand) => BrandsMap[adyenBrand] ?? adyenBrand).filter((brand) => !!brand);
  }
  return [];
};
export {
  mapCartExpressPaymentMethods,
  mapCartRegularPaymentMethods
};
//# sourceMappingURL=apple-pay-payment-methods.js.map
